module.exports = __webpack_public_path__ + "assets/worldliquidity-icon.62e72efe.svg";